export default __webpack_public_path__ + "static/media/Showcase.ee08007c.png";